import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import { getTimeZones } from './thunks'

const initialState: TimeZones = {
  timeZones: [],
  status: 'idle',
  error: null,
}

const slice = createSlice({
  name: 'timeZones',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTimeZones.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(getTimeZones.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getTimeZones.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.timeZones = action.payload.sort(
          (a, b) => a.offset - b.offset || a.displayName.localeCompare(b.displayName),
        )
      })
  },
})

export const selectTimeZones = (state: RootState): TimeZones => state.timeZones

export default slice.reducer
